import React, { useMemo, useCallback, useImperativeHandle, useEffect, useState, useRef, useContext } from 'react';
import DataGrid, { Button, Column, DataGridRef, Editing, FilterRow, Form, Format, Lookup, Pager, Paging, Popup } from "devextreme-react/data-grid";
import { GroupItem, Item } from "devextreme-react/form";
import { dataGridErrorHandling, showError } from '../../utils/errorHandling';
import { useAssistitiTerapieDataSource } from '../../datasources/AssistitiTerapieDataSource';
import { useScreenSize } from '../../utils/media-query';
import { AssistitiApi } from '../../data';
import { apiConfiguration } from '../../apiConfig';
import TenantContext from '../../contexts/tenantContext';
import { FieldDataChangedEvent } from 'devextreme/ui/form';
import { LoadPanel } from 'devextreme-react';


type Props = {
  assistitoId: string;
  onchanged?: () => void;
  readOnly?: boolean;
}

export type AssistitoEditTerapiePanelHandle = {
}

const AssistitoEditTerapiePanel: React.ForwardRefRenderFunction<AssistitoEditTerapiePanelHandle, Props> = (props, ref) => {
  const dataSource = useAssistitiTerapieDataSource(props.assistitoId);
  const { currentTenant } = useContext(TenantContext);
  const [loadPanelVisible, setLoadPanelVisible] = useState<boolean>(false);
  const [formData, setFormData] = useState<any>();
  const gridRef = useRef<DataGridRef>(null);

   useEffect(() => {
      setFormData(null);
  
      (async function () {
        const api = new AssistitiApi(apiConfiguration);
        setLoadPanelVisible(true);
        setFormData(await api.getAssistitoById({ tenantId: currentTenant.Id, assistitoId: props.assistitoId }));
        setLoadPanelVisible(false);
      })();
  
    }, [props.assistitoId]);
  
    function onFieldDataChanged(e: FieldDataChangedEvent) {
      // if (e.dataField==="dataDocumento" && e.component.getEditor('dataOperazione')?.option('value')==null){
      //     e.component.updateData("dataOperazione", e.value);
      // }   
    }

  return (
    <React.Fragment>
      <DataGrid
        dataSource={dataSource}
        ref={gridRef}
        onDataErrorOccurred={dataGridErrorHandling}
        onRowUpdating={e => e.newData = Object.assign({}, e.oldData, e.newData)}
        onRowInserted={props.onchanged}
        onRowRemoved={props.onchanged}
        onRowUpdated={props.onchanged}
      >
        <Editing
          mode="popup"
          allowUpdating={props.readOnly !== true}
          allowAdding={props.readOnly !== true}
          allowDeleting={props.readOnly !== true}>
          <Popup title="Terapie" showTitle={true} />
          <Form colCount={1} formData={formData} onFieldDataChanged={onFieldDataChanged}>
            <Item dataField="nome" editorType='dxTextBox' />
            <Item dataField="richiedente" editorType='dxTextBox' />
            <Item dataField="patologiaMotivante" editorType='dxTextBox' />
            <Item dataField="dataInizio" />
            <Item dataField="tipologiaMedicinale" editorType='dxTextBox' />
            <Item dataField="posologia" editorType='dxTextBox' />
            <Item dataField="note" editorType='dxTextArea' />
          </Form>
        </Editing>
        <Column dataField={'id'} width={90} allowEditing={false} visible={false} />
        <Column dataField={'nome'} caption={'Nome'} />
        <Column dataField={'richiedente'} caption={'Richiedente'} hidingPriority={3} />
        <Column dataField={'patologiaMotivante'} caption={'Patologia Motivante'} />
        <Column dataField={'dataInizio'} caption={'Data Inizio'} dataType='date' format="dd/MM/yyyy" editorOptions={{ type: 'date' }} hidingPriority={4} />
        <Column dataField={'tipologiaMedicinale'} caption={'Tipologia di Medicinale'}  />
        <Column dataField={'posologia'} caption={'Posologia'} hidingPriority={2} />
        <Column dataField={'note'} caption={'Note'} hidingPriority={1} />
      </DataGrid>
      <LoadPanel
        shadingColor="rgba(0,0,0,0.4)"
        position={{ of: '#form' }}
        visible={loadPanelVisible}
        showIndicator={true}
        shading={false}
        showPane={true}
        hideOnOutsideClick={false}
      />
    </React.Fragment>
  );
}

export default React.forwardRef(AssistitoEditTerapiePanel);